<template>
  <b-row>
    <b-col cols="4" style="text-align: left;">
      <h3>Ingrese Datos:</h3>
      <b-form @submit="onSubmit">

        <b-button type="reset" variant="danger" ref="btnReset" class="col-md-12">Limpiar Datos</b-button>

        <b-form-group id="input-group-2" label="Nombre Pasajero" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="form.name"
            required
            autocomplete="off"
            placeholder="Ingrese Nombre"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-phone"
          label="Teléfono Pasajero"
          label-for="input-phone"
          autocomplete="off"
          description=""
        >
        <vue-tel-input v-model="form.phone"  ref="telInput"></vue-tel-input>

        </b-form-group>

        <b-form-group
          id="input-group-phone"
          label="Verificar Teléfono Pasajero"
          label-for="input-phone"
          autocomplete="off"
          description=""
        >
        <vue-tel-input v-model="form.phone2"  ref="telInput2"></vue-tel-input>

        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Correo Electrónico"
          label-for="input-1"
          autocomplete="off"
          description="Necesitamos su dirección de correo electrónico para notificarle"
        >
        <b-form-input
            id="input-1"
            v-model="form.email"
            type="email"
            required
            placeholder="Ingrese Correo Electrónico"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-2"
          label="Vericar Correo Electrónico"
          label-for="input-1"
          autocomplete="off"
          description="Necesitamos verificar su dirección de correo electrónico"
        >
        <b-form-input
            id="input-2"
            v-model="form.email2"
            type="email"
            required
            placeholder="Verificar Correo Electrónico"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-note"
          label="Nota"
          label-for="input-note"
          autocomplete="off"
          description="Agregue notas que ayuden a realizar un mejor servicio"
        >
        <b-form-textarea
          id="input-note"
          v-model="form.note"
          placeholder="Escribe una nota"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
        </b-form-group>


        <b-form-group id="input-group-3" label="Fecha y Hora De Retorno" label-for="input-3">
          <datetime v-model="form.date" type="datetime" :min-datetime="dateMin"	></datetime>
        </b-form-group>


        <b-form-group
          id="input-group-1"
          label="Origen"
          label-for="input-1"
          autocomplete="off"
          :description="form.originAddress"
        >
        <b-form-input
            id="autocomplete"
            v-model="form.origin"
            type="text"
            required
            placeholder="Lugar de Recolección"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-3" label="Destino:" label-for="input-3" v-if="destinations && destinations.length > 1">
          <b-form-select
            id="input-3"
            v-model="form.destination"
            :options="destinations"
            required
          ></b-form-select>
        </b-form-group>

        <b-form-group id="input-group-3" label="Compañía:" label-for="input-3" v-if="companies && companies.length > 1">
          <b-form-select
            id="input-3"
            v-model="form.company"
            :options="companies"
            required
          ></b-form-select>
        </b-form-group>


        <b-form-group id="input-group-3" label="Servicio:" label-for="input-3" v-if="services && form.company !== 'LZpb5aKEpp'">
          <b-form-select
            id="input-3"
            v-model="form.service"
            :options="services"
            required
          ></b-form-select>
        </b-form-group>

        <!--
        <b-form-group id="input-group-4">
          <b-form-checkbox-group v-model="form.checked" id="checkboxes-4">
            <b-form-checkbox value="me">Check me out</b-form-checkbox>
            <b-form-checkbox value="that">Check that out</b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
        -->

        <b-button type="submit" variant="primary" class="col-md-12">Enviar</b-button>
        <!--<b-button type="reset" variant="danger" ref="btnReset" style="margin-left:80px">Reset</b-button>-->
      </b-form>
      <lockscreen v-if="loading">
        <div>Espere un momento ...</div>
      </lockscreen>
      
      <!--
      <b-card class="mt-3" header="Form Data Result">
        <pre class="m-0">{{ form }}</pre>
      </b-card>
      
      Sesión Expira: {{expiresAt}}
      -->
    </b-col>
    <b-col cols="8">
      <google-map :origin="originPlace" :initialPoint="initialPoint" v-if="initialPoint"></google-map>

    </b-col>
  </b-row>
</template>

<script>

  import Vue from 'vue'
  import Parse from 'parse'
  import VueTelInput from 'vue-tel-input'
  import Datetime from 'vue-datetime'

  import GoogleMap from './GoogleMap'
  import * as GoogleMapsLoader from 'google-maps'
  import lockscreen from 'vue-lockscreen'

  // You need a specific loader for CSS files
  import 'vue-datetime/dist/vue-datetime.css'

  Vue.component('lockscreen', lockscreen)
  Vue.use(Datetime)

  Vue.use(VueTelInput, {placeholder: 'Ingrese número telefónico', enabledCountryCode: true, preferredCountries: ['MX', 'US', 'CA', 'ES', 'GB', 'FR', 'DE', 'NL' , 'BR', 'CO']})
  // var geodist = require('geodist')

  var moment = require('moment-timezone')

  export default {
    components: {
      GoogleMap
    },
    data() {
      return {
        loading: false,
        autocomplete: null,
        originPlace: null,
        saving: false,
        form: {
          date: null,
          email: '',
          email2: '',
          name: '',
          phone: '',
          phone2: '',
          origin: '',
          originPosition: null,
          originAddress: null,
          destination: null,
          company: null,
          service: '81xnODWceY',
          countryCode: null,
          note: '',
        },
        destinations: null,
        companies: null,
        services: null,
        show: true,
        expiresAt: null,
        currentSession: null,
        currentUser: null,
        dateMin: null,
        initialPoint: null,
        timezone: null
      }
    },
    async mounted () {
      let vue = this
      GoogleMapsLoader.KEY = 'AIzaSyDFE5IMF4suAO1lsHSrbnFaKs6l1dBljXc'
      GoogleMapsLoader.LIBRARIES = ['geometry', 'places']
      GoogleMapsLoader.LANGUAGE = 'es'
      GoogleMapsLoader.REGION = 'MX'
      GoogleMapsLoader.load((google) => {
        /* eslint-disable no-new */
        /*new google.maps.Map(this.$el, {
          center: new google.maps.LatLng(19.4419179,-99.1634196),
          zoom: 12,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        })
        */

        vue.autocomplete = new google.maps.places.Autocomplete(
        /** @type {!HTMLInputElement} */ (
          document.getElementById('autocomplete')), {
          //types: ['(cities)'],
          componentRestrictions: {country: 'mx'}
        })

        vue.autocomplete.addListener('place_changed', vue.onPlaceChanged);

      })
    },
    async created () {
      let vue = this
      vue.loading = true
      try {
        console.log('created')
        this.currentUser = Parse.User.current()
        this.currentSession = await Parse.Session.current()
        console.log('currentUser',this.currentUser, this.currentUser._getId(), this.currentSession)
        await this.currentUser.fetch()

        if (!this.currentUser.has('pos')) {
          vue.destinations = [{ text: 'Seleccione un destino', value: null }, 'TERMINAL 1', 'TERMINAL 2']
          vue.companies = [{ text: 'Seleccione una compañía', value: null }, { text: 'YELLOWCAB', value: 'XmyHSNAuOu' }, { text: 'PORTOTAXI', value: 'LZpb5aKEpp' }]
          vue.services = [{ text: 'SEDAN', value: '81xnODWceY' }, { text: 'EJECUTIVO', value: 'LSwR1ptmwZ' }]
          // vue.form.service = vue.services[0]
          vue.initialPoint = new google.maps.LatLng(19.4419179,-99.1634196)
          vue.timezone = 'Etc/GMT-6'
        } else {
          vue.destinations = ['TERMINAL CULIACÁN']
          vue.companies = [{ text: 'COMPASS', value: 'n7BpfnpDZ1' }]
          vue.services = [{ text: 'Seleccione un servicio', value: null }, { text: 'SEDAN', value: '81xnODWceY' }, { text: 'COLECTIVO', value: 'KeLsdg8Ezu' }]
          vue.form.company = vue.companies[0].value
          vue.form.destination = vue.destinations[0]
          vue.initialPoint = new google.maps.LatLng(24.7665496,-107.469779)
          vue.timezone = 'Etc/GMT-7'
        }

        this.expiresAt = moment(this.currentSession.get('expiresAt'), vue.timezone).format()
        let now = new Date()
        let dateLimit = new Date(now.getTime() + 4 * 60 * 60 * 1000)
        let m = new moment.tz(dateLimit, vue.timezone)
        console.log(m, m.format())
        this.dateMin = m.format()

      } catch (error) {
        console.log('error login', error)
        this.$router.push('/login');
        return false
      }
      if (!this.currentUser) {
        this.$router.replace('/login')
      } else if (!this.currentUser.get('isSeller')) {
        Parse.User.logOut().then(() => {
          this.$router.replace('/login');
        })
      } else {
        console.log('usuario correcto')
      }
      vue.loading = false
    },
    methods: {
      onPlaceChanged() {
        let vue = this
        vue.originPlace = vue.autocomplete.getPlace()
        // console.log('originPlace', vue.originPlace)
        vue.form.originAddress = vue.originPlace.formatted_address
        vue.form.origin = vue.originPlace.name
        vue.form.originPosition = new Parse.GeoPoint({latitude: vue.originPlace.geometry.location.lat(), longitude: vue.originPlace.geometry.location.lng()})
        /*
        if (place.geometry) {
          map.panTo(place.geometry.location);
          map.setZoom(15);
          search();
        } else {
          document.getElementById('autocomplete').placeholder = 'Enter a city';
        }
        */
      },
      async onSubmit(evt) {
        evt.preventDefault()
        let vue = this
        // INICIO SI CONFIRMA
        const confirm = true
        if (confirm) { 
          let opts = null
          let data = {}
          try {
            vue.loading = true
            let date = new Date(vue.form.date)
            let phoneInt = vue.$refs.telInput.phoneObject.number.international
            let phoneInt2 = vue.$refs.telInput2.phoneObject.number.international

            // Datos de origen
            if (!this.form.originAddress) {
              alert('Tiene que elegir una dirección correcta')
              vue.loading = false
              return false
            }

            if (phoneInt !== phoneInt2) {
              console.log('Numeros', phoneInt, phoneInt2)
              alert('El número telefónico es incorrecto')
              vue.loading = false
              return false
            }

            if (this.form.email !== this.form.email2) {
              alert('El correo electrónico es incorrecto')
              vue.loading = false
              return false
            }
            // Datos de destino
            let destination= null
            if (this.form.destination === 'TERMINAL 1') {
              destination = {
                "__type": "GeoPoint",
                "latitude": 19.4360762,
                "longitude": -99.07190830000002
              }
            } else if (this.form.destination === 'TERMINAL 2') {
              destination = {
                "__type": "GeoPoint",
                "latitude": 19.4182106,
                "longitude": -99.079114
              }
            } else if (this.form.destination === 'TERMINAL CULIACÁN') { // 24.7665496,-107.469779
              destination = {
                "__type": "GeoPoint",
                "latitude": 24.7665496,
                "longitude": -107.469779
              }
            } else {
              alert('Destino Invalido')
              vue.loading = false
              return false
            }

            if (vue.form.company === 'LZpb5aKEpp') {
              vue.form.service = 'LSwR1ptmwZ'
            }

            data = {
              companyId: this.form.company,
              serviceId: this.form.service,
              clientName: this.form.name,
              phone: phoneInt,
              email: this.form.email,
              timezone: this.timezone,
              originName: `${this.form.origin} ${this.form.originAddress}`,
              originAddress: this.form.originAddress,
              originLat: this.form.originPosition.latitude,
              originLon: this.form.originPosition.longitude,
              destinyName: this.form.destination,
              destinyLat: destination.latitude,
              destinyLon: destination.longitude,
              sessionId: this.currentSession.id,
              date,
              userId: this.currentUser.id,
              note: this.form.note
            }

            console.log('data enviada', data)

            let response = null
            try {
              response = await Parse.Cloud.run('createQueueScheduled', { data })
              console.log('response', response)
              const { company, service } = response
              opts = {
                name: vue.form.name,
                phone: phoneInt,
                date: moment(date, vue.timezone).format('DD MMM YYYY HH:mm:SS'),
                email: vue.form.email,
                origin: vue.form.originAddress,
                destination: vue.form.destination,
                company: company.get('name'),
                service: service.get('name'),
                phoneSupport: company.get('phoneSupport'),
                emailSupport: company.get('emailSupport'),
                template: company.get('templateSale')
              }
              await Parse.Cloud.run('reciboReturn', opts)
              vue.$refs.btnReset.click()
              vue.loading = false
              alert('Viaje Redondo Guardado')
            } catch (error) {
              console.log('Error', error)
              alert(error)
              vue.loading = false
            }
            if (!response) {
              alert('Error intentando guardar el viaje')
              vue.loading = false
              return
            }
          } catch (error) {
            alert('Error intentando guardar el viaje')
            vue.loading = false
            console.log('error', error)
          }
        }

        // FINALIZA SI CONFIRMA
        console.log('termina submit')
      },

      onReset(evt) {
        evt.preventDefault()
        // Reset our form values
        this.form.date = null
        this.form.email = ''
        this.form.note = ''
        this.form.name = ''
        this.form.origin = ''
        this.form.originPosition = null
        this.form.originAddress = null
        this.form.destination = null
        this.form.company = null
        this.form.checked = []
        this.form.date = null
        // Trick to reset/clear native browser form validation state
        this.show = false
        this.$nextTick(() => {
          this.show = true
        })
      },
      logout () {
        let vue = this
        Parse.User.logOut().then(() => {
          vue.$router.replace('/');
        })
      },
    }
  }
</script>
<style>
.vdatetime-input {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
}
</style>